module.exports = __webpack_public_path__ + "media/membership_mid.763436de.mp4";